import { computeAmountPreview } from '@hero/core';
import type { Amount } from '@hero/schema';

/**
 * Derives a fee-less load-price + tax preview from any Amount snapshot.
 * Used by reorder modals (web + mobile) so tax is re-derived against
 * the load subtotal, not copied with contextual fees from the source
 * order.
 */
export function buildPreviewFromAmount(amount: Amount | undefined): Amount | null {
  if (!amount) return null;
  const sourceLoadPrice = amount.itemsOriginalSubtotal ?? amount.subtotal ?? 0;
  if (sourceLoadPrice <= 0) return null;

  const appliedTaxes = amount.tax?.applied ?? [];

  return computeAmountPreview({
    currency: amount.currency,
    itemsOriginalSubtotal: sourceLoadPrice,
    tax:
      appliedTaxes.length > 0
        ? { applied: appliedTaxes.map(t => ({ ...t, amount: 0 })) }
        : undefined,
  });
}
